import { getHouseWorkflow as apiGetHouseWorkflow } from './apiService';

/**
 * `GET /v1/houses/:id/workflow` — determina cuál es el siguiente paso
 * pendiente de captura para una vivienda (por ahora siempre es un
 * formulario dinámico identificado por `survey_slug`). No se cachea
 * offline porque el flujo depende del estado del backend en tiempo
 * real; si no hay conexión, el error simplemente se propaga.
 *
 * @typedef {Object} WorkflowNextStep
 * @property {'form'} type
 * @property {string} resource
 * @property {string} surveySlug slug a consultar en `GET /v1/surveys/:slug`
 * @property {'create'|'update'} operation
 * @property {'pending'|'done'} status
 */

function normalizeNextStep(nextStep) {
  if (!nextStep) return null;
  return {
    type: nextStep.type,
    resource: nextStep.resource,
    surveySlug: nextStep.survey_slug,
    operation: nextStep.operation,
    status: nextStep.status,
  };
}

/**
 * @param {string|number} houseId
 * @returns {Promise<{ nextStep: WorkflowNextStep|null }>}
 */
export async function getHouseWorkflow(houseId) {
  const response = await apiGetHouseWorkflow(houseId);
  return { nextStep: normalizeNextStep(response?.data?.next_step) };
}
